import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Akilli geri butonu: Tarayici/SPA gecmisi varsa onceki sayfaya doner,
 * yoksa fallback rotaya gider (varsayilan: ana sayfa).
 *
 * `location.key === 'default'` → kullanici sayfaya direkt URL ile geldi
 * (gecmiste o uygulama icin onceki bir kayit yok); bu durumda navigate(-1)
 * tarayicinin disindaki bir sayfaya gondermeye calisir, biz onun yerine
 * fallback'e yonlendiriyoruz.
 */
export function useSmartBack(fallback: string = '/') {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, location.key, fallback]);
}
